import React, { useMemo, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import {
	Grid,
	Button,
	FormControlLabel,
	Typography,
	RadioGroup,
	TextField,
	Radio,
	Modal,
} from '@mui/material'
import { ServicesContainer, ServiceGrid, ServiceButton } from './StyledComponent'
import { getServicesData } from './data'
import ApplicationView12 from '../../../../../../templates/Forms/Form12/Application12View'
import TakeActionItem from '../../../../../../templates/Forms/TakeActionItem'
import { Toast } from '@egovernments/digit-ui-react-components'
import { useTranslation } from 'react-i18next'


function Services() {
	const { t } = useTranslation()
	const history = useHistory()
	const isLoggedIn = Digit.UserService.getUser()
	const [open, setOpen] = useState(false)
	const [searchOption, setSearchOption] = useState('reference')
	const [placeholderText, setPlaceholderText] = useState('Enter reference number')
	const [applicationNo, setApplicationNo] = useState('')
	const [showToast, setShowToast] = useState(null)
	const [formNo, setFormNo] = useState(null)
	const [formModal, setFormModal] = useState(false)

	const closeToast = () => {
		setShowToast(null)
	};
	useEffect(() => {
		if (!showToast) return;
		const timeOut = setTimeout(closeToast, 3000)
		return () => clearTimeout(timeOut);
	}, [showToast]);

	const toggleModal = () => {
		setOpen(isOpen => !isOpen)
	}
	const toggleFormModal = () => {
		setFormModal(formModal => !formModal)
	}

	const handleClick = (action) => {
		if (typeof action === 'function') {
			return action()
		}
		if (action === '/digit-ui/citizen/profile') {
			const specialAction = isLoggedIn ? action : {
				pathname: '/digit-ui/citizen/login',
				state: {
					from: action,
					userType: 'citizen',
				}
			}
			return history.push(specialAction)
		}
		return history.push(action)
	}
	const handleSearchOptionChange = (event) => {
		setSearchOption(event.target.value)
		setPlaceholderText(
			event.target.value === 'reference'
				? 'Enter reference number'
				: 'Enter mobile number'
		)
	}

	const handleSubmit = (e) => {
		e.preventDefault()
		if (applicationNo.includes('UD')) {
			setShowToast({ error: true, message: `Please search the TCP Applications here...` });
			return 0;
		}
		const formNoMapping = {
			'12': 'form12',
			'11': 'form11',
			'26': 'form26'
		};
		const prefix = applicationNo.slice(5, 7);
		const formNo = formNoMapping[prefix];
		if (formNo) {
			setFormNo(formNo);
		}
		setFormModal(true)
	}
	const formComponents = {
		'form12': ApplicationView12,
		'form11': TakeActionItem,
		'form26': TakeActionItem
	};
	const ModalContent = formComponents[formNo];
	const servicesData = useMemo(() => getServicesData(toggleModal), [])

	return (
		<ServicesContainer>
			<Grid container spacing={4}>
				{servicesData.map((service, index) => (
					<ServiceGrid item xs={12} sm={6} md={4} lg={12 / 4} key={service.label}>
						<ServiceButton onClick={() => handleClick(service.action)} index={index}>
							<img src={service.icon} alt={service.label} />
							<div>{service.label}</div>
						</ServiceButton>
					</ServiceGrid>
				))}
			</Grid>
			<Modal open={open} onClose={toggleModal}>
				<div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: 'white', padding: '20px', borderRadius: '10px', outline: 'none' }}>
					<Typography variant="h5" component="h2" style={{ marginBottom: '20px' }}>
						Know Your Application Status
					</Typography>
					<div>
						<RadioGroup
							aria-label="search option"
							name="searchOption"
							value={searchOption}
							onChange={handleSearchOptionChange}
						>
							<FormControlLabel
								value="reference"
								control={<Radio />}
								label="Search by Application No"
							/>
							{/* <FormControlLabel
								value="mobile"
								control={<Radio />}
								label="Search by Mobile No"
							/> */}
						</RadioGroup>
					</div>
					<TextField
						label={placeholderText}
						placeholder={placeholderText}
						fullWidth
						margin="normal"
						onChange={(e) => setApplicationNo(e.target.value)}
					/>
					<div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
						<Button variant="contained" color="primary" style={{ backgroundColor: '#1F4A7C' }} onClick={handleSubmit}>
							Submit
						</Button>
					</div>
				</div>
			</Modal>
			{
				showToast && (
					<Toast
						error={showToast?.error}
						warning={showToast?.warning}
						label={t(showToast?.message)}
						onClose={closeToast}
						isDleteBtn={true}
					/>
				)
			}
			<Modal open={formModal} onClose={toggleFormModal}>
				<div style={{ display: 'flex', margin: 'auto', width: '70%', height: '100%', overflow: 'scroll' }}>
					{ModalContent && <ModalContent formType={formNo} id={applicationNo} />}
				</div>
			</Modal>
		</ServicesContainer>
	)
}

export default Services
